export default __webpack_public_path__ + "static/media/egoeast_v2.3181a59a.jpg";